import * as actionTypes from './actionTypes';

export const setOriginCity = (city, cityCode, countryCode) => {
    return {
        type: actionTypes.SET_ORIGIN_CITY,
        city: city,
        cityCode: cityCode,
        countryCode: countryCode
    }
}

export const setDestinationCity = (city, cityCode, countryCode) => {
    return {
        type: actionTypes.SET_DESTINATION_CITY,
        city: city,
        cityCode: cityCode,
        countryCode: countryCode
    }
}

export const searchOriginCity = (city) => {
    return {
        type: actionTypes.SEARCH_ORIGIN_CITY,
        city: city
    }
}

export const searchDestinationCity = (city) => {
    return {
        type: actionTypes.SEARCH_DESTINATION_CITY,
        city: city
    }
}

export const setOriginValidation = () => {
    return {
        type: actionTypes.SET_ORIGIN_VALIDATION
    }   
}

export const setDestinationValidation = () => {
    return {
        type: actionTypes.SET_DESTINATION_VALIDATION
    }
}

export const switchCity = () => {
    return {
        type: actionTypes.SWITCH_CITY
    }
}

export const setStartDate = (startDate) => {
    return {
        type: actionTypes.SET_START_DATE,
        startDate: startDate
    }
}

export const setEndDate = (startDate, endDate) => {
    return {
        type: actionTypes.SET_END_DATE,
        startDate: startDate,
        endDate: endDate
    }
}

export const clearEndDate = () => {
    return {
        type: actionTypes.CLEAR_END_DATE
    }
}


// WEBPACK FOOTER //
// ./src/store/actions/bookingEngine.js